import dayjs from "dayjs";

import { apiService, salesOrderService } from "./../services";
export const entityDataGenerator = {
  genSalesOrdersSummary,
  genSalesGraphsSummary,
  genPBHRepairsSummary,
  getStatuses,
  getPriorities,
  genPriceLineSummary,
  genPartCreatorSummary,
};

const odataEntityQuery = [
  {
    tabVal: "Orders",
    objNameQryA: "routeCode",
    strQryA: "S",
    objNameQryB: "itemNumber",
    strQryB: 1,
  },
  {
    tabVal: "Exchanges",
    objNameQryA: "routeCode",
    strQryA: "E",
    objNameQryB: "itemNumber",
    strQryB: 1,
  },
  { tabVal: "Invoices", objNameQryA: "invoiceNumber", strQryA: "" },
];

function genSalesOrdersSummary(rowNums, options, showRecent) {
  // Sales Orders Query
  let strQryA = odataEntityQuery[0].strQryA;
  let objNameQryA = odataEntityQuery[0].objNameQryA; //Get Orders with "S" @routeCode
  let strQryB = odataEntityQuery[0].strQryB; // added to filter an orders with line item 1
  let objNameQryB = odataEntityQuery[0].objNameQryB;

  const getSOrdersData = salesOrderService.searchOrders(
    strQryA,
    objNameQryA,
    strQryB,
    objNameQryB,
    rowNums,
    0,
    options,
    showRecent
      ? dayjs().subtract(6, "months").format("YYYY-MM-DD")
      : false,
  ); // Get SO

  let getSalesOrdersSummary = new Promise((resolve, reject) => {
    return getSOrdersData.then(
      (sOrdersData) => {
        var { ...sOrders } = sOrdersData;
        let soDataSummary = { sOrders };
        return resolve(soDataSummary);
      },
      (err) => {
        return reject(err);
      },
    );
  });

  return new Promise((resolve, reject) => {
    getSalesOrdersSummary.then(
      (dataSummary) => {
        return resolve(dataSummary);
      },
      (err) => {
        return reject(err);
      },
    );
  });
}

const getDates = () => {
  let startDate = dayjs()
    .subtract(2, "months")
    .startOf("month")
    .format("YYYY-MM-DD");

  let endDate = dayjs().format("YYYY-MM-DD");

  return [startDate, endDate];
};
function genSalesGraphsSummary(rowNums) {
  let dates = getDates();

  let startDate = dates[0];
  let endDate = dates[1];

  const getCounts = salesOrderService.getChartCounts(startDate, endDate);

  let getSalesGraphsSummary = new Promise((resolve, reject) => {
    return getCounts.then(
      (counts) => {
        if (counts) {
          let openCount = 0;
          const open = counts.data.map((obj) => {
            obj.openFlag == "T"
              ? (openCount += obj.count)
              : (openCount = openCount);
            return openCount;
          });

          let closedCount = 0;
          const closed = counts.data.map((obj) => {
            obj.openFlag == "F"
              ? (closedCount += obj.count)
              : (closedCount = closedCount);
            return closedCount;
          });

          const monthOne = dayjs()
            .subtract(2, "months")
            .startOf("month")
            .format("MMMM");
          const monthTwo = dayjs()
            .subtract(1, "months")
            .startOf("month")
            .format("MMMM");
          const monthThree = dayjs().startOf("month").format("MMMM");

          let monthOneOrderCount = 0;
          const monthOneOrders = counts.data.map((obj) => {
            obj.openFlag == "T" &&
            obj.routeCode == "S" &&
            obj.month == monthOne
              ? (monthOneOrderCount += obj.count)
              : (monthOneOrderCount = monthOneOrderCount);
            return monthOneOrderCount;
          });

          let monthTwoOrderCount = 0;
          const monthTwoOrders = counts.data.map((obj) => {
            obj.openFlag == "T" &&
            obj.routeCode == "S" &&
            obj.month == monthTwo
              ? (monthTwoOrderCount += obj.count)
              : (monthTwoOrderCount = monthTwoOrderCount);
            return monthTwoOrderCount;
          });

          let monthThreeOrderCount = 0;
          const monthThreeOrders = counts.data.map((obj) => {
            obj.openFlag == "T" &&
            obj.routeCode == "S" &&
            obj.month == monthThree
              ? (monthThreeOrderCount += obj.count)
              : (monthThreeOrderCount = monthThreeOrderCount);
            return monthThreeOrderCount;
          });

          let monthOneExchangeCount = 0;
          const monthOneExchanges = counts.data.map((obj) => {
            obj.openFlag == "T" &&
            obj.routeCode == "E" &&
            obj.month == monthOne
              ? (monthOneExchangeCount += obj.count)
              : (monthOneExchangeCount = monthOneExchangeCount);
            return monthOneExchangeCount;
          });

          let monthTwoExchangeCount = 0;
          const monthTwoExchanges = counts.data.map((obj) => {
            obj.openFlag == "T" &&
            obj.routeCode == "E" &&
            obj.month == monthTwo
              ? (monthTwoExchangeCount += obj.count)
              : (monthTwoExchangeCount = monthTwoExchangeCount);
            return monthTwoExchangeCount;
          });

          let monthThreeExchangeCount = 0;
          const monthThreeExchanges = counts.data.map((obj) => {
            obj.openFlag == "T" &&
            obj.routeCode == "E" &&
            obj.month == monthThree
              ? (monthThreeExchangeCount += obj.count)
              : (monthThreeExchangeCount = monthThreeExchangeCount);
            return monthThreeExchangeCount;
          });

          let soGraphSummary = {
            open,
            closed,
            monthOneOrders,
            monthTwoOrders,
            monthThreeOrders,
            monthOneExchanges,
            monthTwoExchanges,
            monthThreeExchanges,
            monthOneOrdersCount: monthOneOrders.pop(),
            monthOneExchangesCount: monthOneExchanges.pop(),
            monthTwoOrdersCount: monthTwoOrders.pop(),
            monthTwoExchangesCount: monthTwoExchanges.pop(),
            monthThreeOrdersCount: monthThreeOrders.pop(),
            monthThreeExchangesCount: monthThreeExchanges.pop(),
            donutOpen: open.pop() || 0,
            donutClosed: closed.pop() || 0,
          };
          return resolve(soGraphSummary);
        }
      },
      (err) => {
        return reject(err);
      },
    );
  });

  return new Promise((resolve, reject) => {
    getSalesGraphsSummary.then(
      (dataSummary) => {
        return resolve(dataSummary);
      },
      (err) => {
        return reject(err);
      },
    );
  });
}

function genPriceLineSummary(rowNums, batch = undefined) {
  return new Promise((resolve, reject) => {
    const genData = batch
      ? apiService.getPriceLineRequestsQuery({
          rows: rowNums,
          skip: 0,
          property: "PartNumber",
          query: "",
          priceLineFiltering: { batch: batch, archived: false },
        })
      : apiService.getPriceLineRequests(rowNums, 0);

    genData.then(
      (data) => {
        return resolve(data);
      },
      (err) => {
        return reject(err);
      },
    );
  });
}

function genPartCreatorSummary(rowNums) {
  return new Promise((resolve, reject) => {
    const genData = apiService.getPartCreatorPartsNoQuery(rowNums, 0);

    genData.then(
      (data) => {
        return resolve(data);
      },
      (err) => {
        return reject(err);
      },
    );
  });
}

function getPriorities() {
  return new Promise((resolve, reject) => {
    const getPrioriotiesData = apiService.getPBHPriorities();

    getPrioriotiesData.then(
      (prioriotiesData) => {
        return resolve(prioriotiesData);
      },
      (err) => {
        return reject(err);
      },
    );
  });
}

function getStatuses(statusRequested) {
  return new Promise((resolve, reject) => {
    if (statusRequested === "RepairRequest") {
      apiService.getADSStatuses().then(
        (repairStatusesData) => {
          return resolve(repairStatusesData);
        },
        (err) => {
          return reject(err);
        },
      );
    } else {
      return resolve({ status: [] });
    }
  });
}

function genPBHRepairsSummary(rowNums, options) {
  return new Promise((resolve, reject) => {
    const getPBHRepairsData = apiService.getADSRepairs(
      rowNums,
      0,
      { sortby: "CreationDate", sortorder: "desc" },
      options,
    );

    getPBHRepairsData
      .then((pbhRepairsData) => {
        return resolve(pbhRepairsData);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}
